import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {UserModel} from '../models/user.model';
import { ToastrWrapperService } from './toastr-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  baseUrl = environment.baseUrl;
  api = environment.api;
  userMinState$: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);
  userInfoState$: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);

  constructor(private http: HttpClient,private toastr: ToastrWrapperService) {}

  getUserMinInfo(): Observable<any> {
    return this.http.post(`${this.api}/User/GetUserMinInfo`, {});
  }

  getUserInfo(userId: string, workspaceId: string): Observable<any> {
    const body = {
      workspaceId,
      userId,
    };
    return this.http.post(`${this.api}/User/GetUserProfile`, body);
  }

  updateUserInfo(user: UserModel, workspaceid: string): Observable<any>{
    const body = {
      workspaceId: workspaceid,
      userId: user.id,
      avatarPath: user.avatarPath,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      cellPhoneNumber: user.cellPhoneNumber,
      nationalCode: user.nationalCode,
      userCustomFields: user.userCustomFields,
    };
    return this.http.post(`${this.api}/User/UpdateUserInfo`,body);
  }

  uploadFileApi(uploadType: string, workspaceId: string, file: File): Observable<any> {
    const body = new FormData();
    body.append('formFile', file, file.name);
    return this.http.post<any>(
      `${this.api}/File/UploadImage/${uploadType}/${workspaceId}`,
      body,
    );
  }

  uploadFile(uploadType: string, workspaceId: string, file: File,user: UserModel) {
    this.uploadFileApi(uploadType, workspaceId, file).subscribe(
      (res) => {
        user.avatarPath = res.data.path;
        this.updateUser(user, workspaceId);
      },
      (err) => {
        if(err.error.message === 'Failed to read the request form. Request body too large.') {
          this.toastr.showError('سایز تصویر منتخب باید حداکثر ۱ مگابایت باشد.');
        }
      },
      () => {},
    );
  }
  updateUserAvaterPath(path: any) {
    const updateUserMinInfo = {...this.userMinState$.value};
    const updateUserInfo = {...this.userInfoState$.value};
    updateUserMinInfo.avatarPath = path;
    updateUserInfo.avatarPath = path;
    this.userMinState$.next(updateUserMinInfo);
    this.userInfoState$.next(updateUserInfo);
  }

  loadUserInfo(userId: string, workspaceId: string): void {
    this.getUserInfo(userId, workspaceId).pipe(map(res => res.data)).subscribe(userInfo => {
    this.updateUserInfoState(userInfo);
    });
  }

  loadUserMinInfo() {
    this.getUserMinInfo().subscribe(
      (userMinInfo) => {
        this.updateUserMinState(userMinInfo.data);
      },
    );
  }

  updateUser(user: UserModel,workspaceId: string): void {
    this.updateUserInfo(user, workspaceId).subscribe(
      (res) => {
        this.updateUserInfoState(res.data);
        const userMinInfo = {
          id: res.data.id,
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          avatarPath: res.data.avatarPath,
          isSuperAdmin: res.data.isSuperAdmin,
          workspacesHighestLevel: user.workspacesHighestLevel
        };
        this.updateUserMinState(userMinInfo);
        this.toastr.showSuccess();
      },
      (errorRes) => {
        this.toastr.showError(errorRes.error.message);
      },
    );
  }

  updateUserInfoState(userInfo: UserModel): void {
    this.userInfoState$.next(userInfo);
  }

  getUserInfoState$(): Observable<any> {
    return this.userInfoState$.asObservable();
  }

  getUserMinState(): Observable<UserModel>{
    return this.userMinState$.asObservable();
  }

  getUserMinInfoValue(): UserModel {
    return this.userMinState$.getValue();
  }
  updateUserMinState(newUserMinState: UserModel): void {
    const userInfo = this.userMinState$?.value;
    if(newUserMinState?.id === userInfo?.id || userInfo === null || newUserMinState === null) {
      this.userMinState$.next(newUserMinState);
    }
  }


}
